<template>
  <div class="lessee-info">
    <div class="left-fan">
      <p>{{echartsData[1]}}m²</p>
      <div>未出租</div>
    </div>
    <div class="center-echarts">
      <div ref="main" class="echarts"></div>
      <div class="core"></div>
    </div>
    <div class="right-fan">
      <p>{{echartsData[0]}}m²</p>
      <div>已出租</div>
    </div>
  </div>
</template>

<script>
import * as echarts from "echarts"
export default {
  props: {
    infoData: {
      type: Object,
      default: () => {}
    }
  },
  data() {
    return {
      myChart: null,
      colors: ["#267ECC", "#1EE7E7"],
      echartsData: [0, 0]
    }
  },
  watch: {
    infoData (val) {
      const { officeAreaRented = 0, officeAreaNoRented = 0 } = val
      this.echartsData = [].concat([officeAreaRented, officeAreaNoRented])
      this.drawChart()
    }
  },
  methods: {
    drawChart() {
      this.myChart && this.myChart.dispose()
      this.myChart = echarts.init(this.$refs.main)
      const option = {
        legend: {
          show: false,
        },
        series: [
          {
            name: "外边框",
            type: "pie",
            hoverAnimation: false,
            radius: ["60%", "85%"],
            minAngle: 10,
            label: {
              normal: {
                show: false,
              },
            },
            itemStyle: {
              color: (params) => this.colors[params.dataIndex],
              opacity: 0.4
            },
            data: this.echartsData
          },
          {
            type: "pie",
            hoverAnimation: false, // 鼠标移入变大
            radius: ["60%", "65%"],
            data: this.echartsData,
            minAngle: 10,
            itemStyle: {
              color: (params) => this.colors[params.dataIndex],
              borderRadius: this.$remToPx(0.03),
              borderColor: 'rgba(46,65,85,0.50)',
              borderWidth: this.$remToPx(0.03)
            },
            labelLine: {
              show: false,
            },
            label: {
              show: false,
            },
          },
        ],
      }
      this.myChart.setOption(option)
    },
  },
  beforeDestroy () {
    this.myChart && this.myChart.dispose()
    this.myChart = null
  }
}
</script>

<style lang="scss" scoped>
.lessee-info {
  // height: 2rem;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
  .left-fan, .right-fan {
    flex-basis: 30%;
    text-align: center;
    p {
      color: #267ECC;
      font-size: 0.2rem;
    }
    div {
      color: #E9F5FF;
      font-size: 0.12rem;
    }
  }
  .center-echarts {
    flex-basis: 40%;
    width: 100%;
    height: 100%;
    position: relative;
    .echarts {
      width: 100%;
      height: 100%;
    }
    .core {
      position: absolute;
      left: 0;
      right: 0;
      top: 0;
      bottom: 0;
      width: 0.9rem;
      height: 0.9rem;
      border-radius: 50%;
      border: 0.02rem dashed #5c6c78;
      margin: auto;
      color: #fff;
      background: url("~@/assets/images/bigScreen/icon-czI.png");
      background-size: 50% 50%;
      background-position: center;
      background-repeat: no-repeat;
    }
  }
}
</style>